export { default as Migration } from './Migration'
export { default as Hero } from './Hero'
export { default as PartnerBenefits } from './PartnerBenefits'
export { default as Quote } from './Quote'
export { default as Sites } from './Sites'
export { default as BigData } from './BigData'
export { default as SecurityAssessment } from './SecurityAssessment'
export { default as War } from './War'
